import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNubankComponent } from './simple-icons-nubank.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNubankComponent ],
    exports:      [ SimpleIconsNubankComponent ],
    bootstrap:    []
})
export class SimpleIconsNubankModule {}
